(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6405],{

/***/ 67456:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive",
      function () {
        return __webpack_require__(89052);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ archive; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 13 modules
var createTheme = __webpack_require__(68239);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js + 5 modules
var ThemeProvider = __webpack_require__(22430);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./Layout/Layout.jsx + 7 modules
var Layout = __webpack_require__(24987);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/modules/Archive.module.scss
var Archive_module = __webpack_require__(13006);
var Archive_module_default = /*#__PURE__*/__webpack_require__.n(Archive_module);
;// CONCATENATED MODULE: ./public/images/sweden.svg
var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgSweden(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#006aa7",
    d: "M0 0h16v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fecc00",
    d: "M5 0h2v10H5z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fecc00",
    d: "M0 4h16v2H0z"
  })));
}
/* harmony default export */ var sweden = (SvgSweden);
;// CONCATENATED MODULE: ./public/images/denmark.svg
var denmark_path, denmark_path2, denmark_path3;
function denmark_extends() { denmark_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return denmark_extends.apply(this, arguments); }

function SvgDenmark(props) {
  return /*#__PURE__*/react.createElement("svg", denmark_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370 280"
  }, props), denmark_path || (denmark_path = /*#__PURE__*/react.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h370v280H0z"
  })), denmark_path2 || (denmark_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M120 0h40v280h-40z"
  })), denmark_path3 || (denmark_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 120h370v40H0z"
  })));
}
/* harmony default export */ var denmark = (SvgDenmark);
;// CONCATENATED MODULE: ./public/images/united-kingdom.svg
var _clipPath, _clipPath2, _g;
function united_kingdom_extends() { united_kingdom_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return united_kingdom_extends.apply(this, arguments); }

function SvgUnitedKingdom(props) {
  return /*#__PURE__*/react.createElement("svg", united_kingdom_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10 0 40 30",
    width: 230,
    height: 150
  }, props), _clipPath || (_clipPath = /*#__PURE__*/react.createElement("clipPath", {
    id: "united-kingdom_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 0v30h60V0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/react.createElement("clipPath", {
    id: "united-kingdom_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M30 15h30v15zv15H0zH0V0zV0h30z"
  }))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#united-kingdom_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M0 0v30h60V0z",
    fill: "#012169"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 0l60 30m0-30L0 30",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/react.createElement("path", {
    d: "M0 0l60 30m0-30L0 30",
    clipPath: "url(#united-kingdom_svg__b)",
    stroke: "#C8102E",
    strokeWidth: 4
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30 0v30M0 15h60",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/react.createElement("path", {
    d: "M30 0v30M0 15h60",
    stroke: "#C8102E",
    strokeWidth: 6
  }))));
}
/* harmony default export */ var united_kingdom = (SvgUnitedKingdom);
;// CONCATENATED MODULE: ./public/images/norway.svg
var norway_path, norway_path2, norway_path3, _path4, _path5;
function norway_extends() { norway_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return norway_extends.apply(this, arguments); }

function SvgNorway(props) {
  return /*#__PURE__*/react.createElement("svg", norway_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 800"
  }, props), norway_path || (norway_path = /*#__PURE__*/react.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  })), norway_path2 || (norway_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  })), norway_path3 || (norway_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  })));
}
/* harmony default export */ var norway = (SvgNorway);
;// CONCATENATED MODULE: ./pages/archive.jsx
// pages/404.js












var theme = (0,createTheme/* default */.Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#202020"
    }
});
function Archive() {
    var languages = [
        {
            value: "gb",
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(united_kingdom, {}),
            title: "English"
        },
        {
            value: "se",
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(sweden, {}),
            title: "Swedish"
        },
        {
            value: "no",
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(norway, {}),
            title: "Norwegian"
        },
        {
            value: "dk",
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(denmark, {}),
            title: "Danish"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ThemeProvider/* default */.Z, {
        theme: theme,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://www.first-class.com", "/archive")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Explore Our Article Archive: Travel Insights and Stories"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Archive_module_default()).archiveCountrySelectContainer, "container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "w-full text-center font-fragment text-5xl my-8",
                        children: "Archive articles"
                    }),
                    languages.map(function(lang) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/archive/".concat(lang.value),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Archive_module_default()).archiveCountrySelectItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Archive_module_default()).archiveItemImage,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Archive_module_default()).archiveImageContainer,
                                            children: lang.image
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()((Archive_module_default()).archiveItemTitle, "font-libre"),
                                        children: lang.title
                                    })
                                ]
                            })
                        }, lang.value);
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var archive = ((0,Layout/* withLayout */.X)(Archive, false));


/***/ }),

/***/ 13006:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"archiveItem":"Archive_archiveItem__jpoCB","archiveItemsContainer":"Archive_archiveItemsContainer__Masr7","archiveItemImage":"Archive_archiveItemImage__gfeTA","archiveItemTitle":"Archive_archiveItemTitle__Qz9MY","archiveItemContent":"Archive_archiveItemContent__A4cjR","archiveCountrySelectContainer":"Archive_archiveCountrySelectContainer__Tt1SF","archiveCountrySelectItem":"Archive_archiveCountrySelectItem__nSW7g","archiveImageContainer":"Archive_archiveImageContainer__yhBti"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(67456); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);